<template>
  <div>
    <!--搜索栏-->
    <searchBar
      :search-form="searchForm"
      name
      btn-add
      @handleAdd="handleAdd"
      @handleSearch="getData"
    ></searchBar>

    <!--表格-->
    <el-table :data="tableData" border>
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="60"
      ></el-table-column>
      <el-table-column
        v-for="(item, index) in tableHeader"
        :key="index"
        :label="item"
        :prop="index"
        align="center"
      ></el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="200">
        <template slot-scope="scope">
          <el-button
            @click="handleDelete(scope.row)"
            type="text"
            style="color:red"
            size="mini"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="block">
      <el-pagination
        class="pagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="size"
        layout=" prev, pager, next, jumper, sizes"
        :total="totalElements"
      ></el-pagination>
    </div>

    <!--新增Dialog-->
    <el-dialog
      title="添加报警处理人"
      :show-close="false"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="100px"
        label-suffix="："
        label-position="right"
        :status-icon="true"
      >
        <el-form-item
          label="姓名"
          prop="name"
          label-width="100px"
          style="text-align: left"
        >
          <el-input
            v-model="form.name"
            size="medium"
            placeholder="姓名"
            style="width: 50%"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="手机号"
          prop="mobile"
          label-width="100px"
          style="text-align: left"
        >
          <el-input
            v-model="form.mobile"
            size="medium"
            placeholder="手机号"
            style="width: 50%"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCancel">取消</el-button>
        <el-button type="primary" @click="dialogConfirm()">确定</el-button>
      </div>
    </el-dialog>

    <!--预览图dialog-->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import Axios from "axios"
import apiUrl from "@/assets/http/apiUrl"
import { quillEditor } from "vue-quill-editor"
import "quill/dist/quill.snow.css"
import { quillRedefine } from "vue-quill-editor-upload"

export default {
  name: "newsManager",
  components: {
    quillEditor,
    quillRedefine,
  },
  data() {
    let Self = this

    // 表单验证
    let validate = (rule, value, callback) => {
      if (!!value) {
        this.$refs.form.validateField("checkPass")
        callback()
      } else {
        callback(new Error("请上传icon"))
      }
    }

    return {
      // 页面初始数据
      totalElements: 10,
      currentElements: 10,
      totalPages: 1,
      size: 10,
      page: 1,

      serverUrl: apiUrl.ServerUrl,

      // 搜索栏初始化
      searchForm: {
        name: "",
        status: null,
      },

      // 表头初始化
      tableHeader: {
        name: "姓名",
        mobile: "手机号",
      },
      // 表格数据
      tableData: [],

      // dialog可见性
      dialogFormVisible: false,
      dialogUploadVisible: false,

      // 上传文件列表
      file: "",

      // 新增表单
      form: {
        uid: "",
        name: "",
        mobile: "",
      },

      // 表单验证规则
      rules: {
        name: {
          required: true,
          message: "请输入 ",
          trigger: "blur",
        },
        mobile: {
          required: true,
          message: "请输入 ",
          trigger: "blur",
        },
      },

      // 头像上传初始化
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,

      // 编辑器配置
      editorOption: {
        placeholder: "请详细填写活动内容",
        modules: {
          toolbar: [
            "bold",
            "italic",
            "underline",
            "strike",
            "align",
            "link",
            "image",
          ],
        },
      },

      // 当前选择的活动
      currentActityUid: "",

      // 级联选择器配置
      props: {
        value: "uid",
        label: "name",
        multiple: true,
      },
      optionType: [
        {
          label: "基本服务",
          value: 1,
        },
        {
          label: "折扣服务",
          value: 2,
        },
      ],
    }
  },
  methods: {
    /*图片预览
     * */
    getImgPreviewList(url) {
      let arr = new Array(this.serverUrl + url)
      return arr
    },

    /*请求数据
     * */
    getData() {
      this.request({
        url: "/manager/handler/findHandlers",
        method: "get",
        params: {
          status: this.searchForm.status == "" ? null : this.searchForm.status,
          page: this.page,
          size: this.size,
          name: this.searchForm.name,
        },
      })
        .then(res => {
          this.size = res.data.data.size
          this.page = res.data.data.page
          this.totalElements = Number(res.data.data.totalElements)
          this.totalElements = Number(res.data.data.totalElements)
          this.totalPages = res.data.data.totalPages
          this.currentElements = res.data.data.currentElements

          this.tableData = res.data.data.content
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*更改单页数据数量
     * */
    handleSizeChange(size) {
      this.size = size
      this.getData()
    },

    /*页码跳转
     * */
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },

    /*设置通知发布或屏蔽
     * */
    handlePublish(rowData, status) {
      this.request({
        url: "/manager/handlerType/updateStatus",
        params: {
          uid: rowData.uid,
          status: status,
        },
        method: "post",
      })
        .then(res => {
          this.$message.success("操作成功")
          this.getData()
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*编辑
     * */
    handleEdit(rowData) {
      this.form = {
        ...rowData,
      }

      this.dialogFormVisible = true
    },

    /*结束
     * */
    handleFinish(rowData) {
      this.form = {
        ...rowData,
      }

      this.dialogFormVisible = true
    },

    /*添加操作
     * */
    handleAdd() {
      this.dialogFormVisible = true
    },

    /*删除
     * */
    handleDelete(rowData) {
      this.$confirm("确认删除?")
        .then(() => {
          this.request({
            url: "/manager/handler/deleteHandler",
            params: {
              uid: rowData.uid,
            },
            method: "DELETE",
          })
            .then(res => {
              this.$message.success("删除成功")
              this.getData()
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        })
        .catch()
    },

    /*dialog提交
     * */
    dialogConfirm() {
      this.$refs.form.validate(valid => {
        console.log(valid)
        if (valid) {
          this.dialogFormVisible = false

          this.request({
            url: "/manager/handler/addOrUpdateHandler",
            data: {
              uid: this.form.uid,
              name: this.form.name,
              mobile: this.form.mobile,
            },
            method: "post",
          })
            .then(res => {
              if (res.data.status === "BAD_REQUEST") {
                this.$message.warning(res.data.message)
              }

              this.getData()
              this.form = {}
            })
            .catch(err => {})
        }
      })
    },

    /*dialog取消
     * */
    dialogCancel() {
      this.form = {}
      this.center = {}
      this.dialogFormVisible = false
    },

    /*覆盖默认上传请求
     * */
    overwriteDefault(e) {
      let tmpFile = new FormData()
      tmpFile.append("file", e.file)
      this.file = tmpFile
      Axios.post(apiUrl.server + "/manager/upload/uploadAvatar", this.file, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
        .then(res => {
          if (res.data.status === "OK") {
            this.$message.success("上传成功")
            this.form.icon = res.data.data
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    uploadCancel() {
      this.dialogUploadVisible = false
      this.form = {}
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },

    // 准备富文本编辑器
    onEditorReady(editor) {},
    // 富文本编辑器 失去焦点事件
    onEditorBlur(editor) {},
    // 富文本编辑器 获得焦点事件
    onEditorFocus(editor) {},
    // 富文本编辑器 内容改变事件
    onEditorChange(editor) {
      this.form.conditions = editor.html
    },
  },
  mounted() {
    this.getData()
  },
  beforeDestroy() {
    this.editor = null
    delete this.editor
  },
  created() {
    let token = localStorage.getItem("token")
    this.editorOption = quillRedefine({
      // 图片上传的设置
      uploadConfig: {
        action: apiUrl.server + "/manager/upload/uploadPic", // 必填参数 图片上传地址
        // 必选参数  res是一个函数，函数接收的response为上传成功时服务器返回的数据
        // 你必须把返回的数据中所包含的图片地址 return 回去
        name: "file",
        res: respnse => {
          console.log(apiUrl.server.split("/api")[0] + respnse.data)
          return apiUrl.server.split("/api")[0] + respnse.data // 这里切记要return回你的图片地址
        },
        header: (xhr, formData) => {
          xhr.setRequestHeader("Authorization", token)
          formData.append("uid", this.form.uid)
        },
      },
    })
  },
}
</script>

<style scoped>
.bm-view {
  width: 100%;
  height: 300px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 200px;
  height: 150px;
  object-fit: cover;
  display: block;
}
</style>
